import { scrollToElement } from './scroll';

export const getPaymentLink = (language, planType) => {
  const isBR = language === 'pt-br';

  if (planType === 'weekly') {
    return isBR
      ? import.meta.env.VITE_STRIPE_WEEKLY_BR_PAYMENT_LINK || '#'
      : import.meta.env.VITE_STRIPE_WEEKLY_INT_PAYMENT_LINK || '#';
  }

  return isBR
    ? import.meta.env.VITE_STRIPE_MONTHLY_BR_PAYMENT_LINK || '#'
    : import.meta.env.VITE_STRIPE_MONTHLY_INT_PAYMENT_LINK || '#';
};

export const handleCheckout = (paymentLinkUrl, onError) => {
  if (!paymentLinkUrl || paymentLinkUrl === '#') {
    if (typeof onError === 'function') {
      onError();
    }
    return;
  }
  window.location.href = paymentLinkUrl;
};

export const scrollToPricing = () => {
  scrollToElement('pricing');
};